export default {
  ACCESSIBILITY_BODY_BLUR: 'ACCESSIBILITY_BODY_BLUR',
  ACCESSIBILITY_BODY_FOCUS: 'ACCESSIBILITY_BODY_FOCUS',
  CHANGE_LANGUAGE: 'CHANGE_LANGUAGE',
  OPEN_PREFERENCE_CENTER: 'OPEN_PREFERENCE_CENTER',
  PAGE_VIEW: 'PAGE_VIEW',
  READY: 'READY',
  RESIZE: 'RESIZE',
  SCROLL: 'SCROLL',
  TECHNICAL_ERROR: 'TECHNICAL_ERROR',
};
